export const AiReputationLoaderDialog = () => (
  <div
    className="audit-loader-overlay"
    role="dialog"
    aria-modal="true"
    aria-label="Generating AI reputation analysis"
  >
    <div className="audit-loader-card">
      <div className="audit-spinner-container">
        <div className="audit-spinner-ring audit-ring-1" />
      </div>
      <h2 className="audit-loader-title">Sampling AI reputation sources</h2>
      <p className="audit-loader-subtitle">
        We are sampling web-grounded answers and visible sources. This usually takes about two
        minutes.
      </p>
    </div>
  </div>
);
